// Style-section tile grid: a None tile + the seven effect tiles. Active
// state mirrors objProps.textEffects (slot model — Shadow-slot and
// stroke-slot effects can be lit at the same time; Sticker occupies both).
//
// Tap semantics (spec §6): lit tile → remove that effect; unlit tile → apply
// the effect's defaults (the engine displaces whatever held the slot); None →
// clear both slots and restore the fill.
//
// gatedIds (additive, 3D-controls lane): a Set of effect ids to render
// DISABLED — the host (TextCustomizePanel) gates the effects that cannot
// apply to a 3D selection and owns the hint wording below the grid. A LIT
// gated tile stays enabled: tapping it removes the effect, and trapping an
// active effect behind a disabled tile would be worse than the gate.
import React from 'react';
import { EFFECT_DEFS, EFFECT_ORDER, effectDefaults } from './effectDefs';

export default function EffectTiles({ objProps, apply, editor, gatedIds = null }) {
  const fx = objProps.textEffects || {};
  const activeIds = new Set([fx.shadow?.id, fx.stroke?.id].filter(Boolean));
  const hasAny = activeIds.size > 0;

  const onTile = (id) => {
    if (activeIds.has(id)) {
      apply(() => editor?.removeTextEffect(id), 'now');
    } else {
      apply(() => editor?.applyTextEffect(id, effectDefaults(EFFECT_DEFS[id])), 'now');
    }
  };

  return (
    <div className="cce-fx-grid">
      <button
        type="button"
        className={`cce-fx-tile${hasAny ? '' : ' active'}`}
        onClick={() => apply(() => editor?.clearTextEffects(), 'now')}
      >
        <span className="cce-fx-tile-preview">Aa</span>
        <span className="cce-fx-tile-label">None</span>
      </button>
      {EFFECT_ORDER.map((id) => {
        const def = EFFECT_DEFS[id];
        const active = activeIds.has(id);
        const gated = !!gatedIds?.has(id) && !active;
        return (
          <button
            key={id}
            type="button"
            className={`cce-fx-tile${active ? ' active' : ''}${gated ? ' cce-fx-tile-gated' : ''}`}
            disabled={gated}
            onClick={() => onTile(id)}
          >
            <span className="cce-fx-tile-preview" style={def.tilePreview()}>Aa</span>
            <span className="cce-fx-tile-label">{def.label}</span>
          </button>
        );
      })}
    </div>
  );
}
